import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuthStore } from "../stores/auth";
import { FeedbackEventRendererWrapper } from "../components/feedback-event-renderer-wrapper";

/**
 * Root layout component that wraps the entire application
 * Handles global providers, styles, and layer containers for portal routing
 *
 * Layer hierarchy:
 * - Content (z-index 0) with nested popover layer (z-index 2)
 * - Popover layer (z-index 2) for dropdowns/tooltips
 * - Toasts layer (z-index 3) - contains Toast.Viewport and its portaled toasts
 * - Overlay layer (z-index 4) - contains portaled alert dialogs
 */
export function RootLayout() {
	const location = useLocation();

	// Check auth once on mount for protected routes.
	// Re-checking on every pathname causes isLoading flicker and remounts the dashboard shell.
	useEffect(() => {
		const checkAuthAsync = async () => {
			const { checkAuth } = useAuthStore.getState();
			const isAuthPage = /^\/(login|register|auth)/.test(location.pathname);
			if (!isAuthPage) {
				await checkAuth();
			}
		};
		void checkAuthAsync();
		// Intentionally run once on mount.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<FeedbackEventRendererWrapper />
			<Outlet />
		</>
	);
}
